export const Footer = ({ isOpen }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <footer
        className={`
          fixed bottom-0 right-0 z-30
          flex flex-col md:flex-row justify-between items-center px-6 py-3
          transition-all duration-300 ease-in-out
          left-0
          bg-gob-azul-oscuro text-white/80 border-t-2 border-gob-rojo
          ${isOpen ? "md:left-64" : "md:left-0"}
        `}
      >
        <div className="text-center md:text-left text-xs mb-2 md:mb-0 flex-1">
          <p>Desarrollo: Subsecretaría de Tecnologías y Conectividad</p>
        </div>

        <div className="text-center md:text-right text-xs flex-1">
          <p>
            &copy; {currentYear}{" "}
            <span className=" transition-colors font-semibold">
              Gobierno de Salta
            </span>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
